import { VEC2, Vector } from "math";
import { computed, reactive, type Ref } from "vue"

const state = reactive<{
  x: number;
  y: number;
  deltaX: number;
  deltaY: number;
  prevX: number;
  prevY: number;
  pageX: number;
  pageY: number;
  listener?: Function
}>({
  x: 0,
  y: 0,
  deltaX: 0,
  deltaY: 0,
  prevX: 0,
  prevY: 0,
  pageX: 0,
  pageY: 0,
  listener: undefined
})

export type UseMousePosition = {
  position: Ref<Vector>;
  relativePosition: Ref<Vector>;
  delta: Ref<Vector>;
}

export const useMousePosition = (): UseMousePosition => {
  if (!state.listener) {
    const listener = (event: MouseEvent) => {
      const deltaX = event.clientX - state.prevX;
      const deltaY = event.clientY - state.prevY;
      state.deltaX = deltaX;
      state.deltaY = deltaY;
      state.prevX = state.x;
      state.prevY = state.y;
      state.x = event.clientX;
      state.y = event.clientY;
      state.pageX = event.pageX;
      state.pageY = event.pageY;
    }
    window.addEventListener('mousemove', listener);
    state.listener = listener;
  }

  const position = computed(() => VEC2(state.x, state.y));
  const delta = computed(() => VEC2(state.deltaX, state.deltaY));
  const relativePosition = computed(() => position.value.add(VEC2(state.pageX, state.pageY)));

  return { position, relativePosition, delta };
}
